import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SERVICES = ['Standard Clean', 'Deep Clean', 'Move In / Move Out', 'Commercial', 'Other'];
const SOURCES = ['Phone call', 'Referral', 'Walk-in', 'Social media', 'Other'];
const field = 'w-full h-10 rounded-md border border-[#dcded2] bg-white px-3 text-sm mt-1';

export const AddLeadDialog = ({ headers, onClose, onSaved }) => {
  const [f, setF] = useState({ full_name: '', email: '', phone: '', service_needed: '', lead_source: 'Phone call', additional_details: '' });
  const [rid] = useState(() => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`));
  const [busy, setBusy] = useState(false);
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.full_name.trim()) { toast.error('Add the lead’s name'); return; }
    if (!f.email.trim() && !f.phone.trim()) { toast.error('Add an email or a phone number'); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/api/admin/quote-requests`, { ...f, client_submission_id: rid }, { headers });
      toast.success('Lead added. No email was sent.');
      onSaved(r.data);
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not add the lead'); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="add-lead-dialog">
        <DialogHeader>
          <DialogTitle>Add lead</DialogTitle>
          <DialogDescription>For phone calls, referrals and walk-ins. The lead starts as New; nothing is sent to them.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <label className="block text-xs text-[#5f6455]">Name<input className={field} value={f.full_name} onChange={up('full_name')} maxLength={120} data-testid="add-lead-name" /></label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="block text-xs text-[#5f6455]">Email<input type="email" className={field} value={f.email} onChange={up('email')} maxLength={200} data-testid="add-lead-email" /></label>
            <label className="block text-xs text-[#5f6455]">Phone<input className={field} value={f.phone} onChange={up('phone')} maxLength={40} data-testid="add-lead-phone" /></label>
            <label className="block text-xs text-[#5f6455]">Service<select className={field} value={f.service_needed} onChange={up('service_needed')} data-testid="add-lead-service"><option value="">Not sure yet</option>{SERVICES.map((s) => <option key={s}>{s}</option>)}</select></label>
            <label className="block text-xs text-[#5f6455]">Source<select className={field} value={f.lead_source} onChange={up('lead_source')} data-testid="add-lead-source">{SOURCES.map((s) => <option key={s}>{s}</option>)}</select></label>
          </div>
          <label className="block text-xs text-[#5f6455]">Notes<textarea className={`${field} h-20 py-2`} value={f.additional_details} onChange={up('additional_details')} maxLength={2000} data-testid="add-lead-notes" /></label>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-[5px] border border-[#dcded2] text-xs" data-testid="add-lead-cancel">Cancel</button>
            <button disabled={busy} className="px-4 py-2 rounded-[5px] bg-[#f36a19] text-[#171912] text-xs font-bold" data-testid="add-lead-submit">{busy ? 'Adding…' : 'Add lead'}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
